import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import "./Blog.css";
import "./BlogPostSafetyManager.css";
import "./BlogPostExecutive.css";

function BlogPostExemption() {
  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>경영자 가이드</span>
          </div>
          <h1>면책된 회사와 안 된 회사,<br />딱 하나의 차이</h1>
          <div className="blog-post-meta">
            <span className="meta-tag" style={{ background: "#fce7f3", color: "#9d174d" }}>경영자 가이드</span>
            <span>2026.06.05</span>
            <span>읽기 4분</span>
          </div>
        </div>

        <article className="sm-article">

          <p>중대재해처벌법 시행 이후 나온 판결들을 보면 한 가지 패턴이 보입니다.</p>
          <p>면책된 회사와 안 된 회사는 안전관리 수준이 크게 달랐을까요?</p>
          <p>꼭 그렇지 않습니다.</p>

          <div className="ex-hook">
            <p>차이는 안전관리를 <strong>"했느냐"</strong>가 아니라<br />했다는 것을 <strong>"증명할 수 있느냐"</strong>였습니다.</p>
          </div>

          <h2 className="sm-h2">판례로 보는 두 회사</h2>

          <div className="ex-case-grid">
            <div className="ex-case good">
              <div className="ex-case-label good-label">🟢 면책 인정</div>
              <div className="ex-case-title">안전보건관리체제가 실제로 작동했다</div>
              <ul className="ex-case-list">
                <li>위험성평가를 월 1회 정기 실시, 결과 문서 보관</li>
                <li>사고 발생 부분에 사전 조치 기록 존재</li>
                <li>안전교육 실시 일지, 참석자 서명 확인</li>
                <li>경영책임자 반기 점검 일지에 서명</li>
                <li>위험 보고 → 조치 결과 기록 연결</li>
              </ul>
              <div className="ex-case-verdict">법원 판단: "체계가 실제로 작동했다"</div>
            </div>
            <div className="ex-case bad">
              <div className="ex-case-label bad-label">🔴 면책 부정</div>
              <div className="ex-case-title">서류는 있었지만 작동 흔적이 없었다</div>
              <ul className="ex-case-list">
                <li>위험성평가 최초 1회만, 이후 갱신 없음</li>
                <li>동일 위험이 반복 보고됐지만 조치 기록 없음</li>
                <li>안전교육 서명부만 있고 내용 증빙 없음</li>
                <li>경영책임자 점검 기록 없음</li>
                <li>안전보건계획서 있으나 실행 기록 없음</li>
              </ul>
              <div className="ex-case-verdict">법원 판단: "형식만 있고 작동하지 않았다"</div>
            </div>
          </div>

          <h2 className="sm-h2">딱 하나의 차이</h2>

          <div className="ex-one-diff">
            <div className="ex-one-diff-label">결론</div>
            <p>체계를 <strong>만들었느냐</strong>가 아니라<br />체계가 <strong>실제로 작동했다는 기록</strong>이 있느냐.</p>
          </div>

          <p>안전관리를 잘 하고 있어도 기록이 없으면 법적으로는 "하지 않은 것"입니다. 법원은 기억이나 진술이 아닌 서류로 판단합니다.</p>

          <h2 className="sm-h2">작동했다는 기록, 어떻게 만드나</h2>

          <p>PDCA 사이클을 문서로 남기는 것입니다.</p>

          <div className="ex-pdca">
            {[
              { step: "P", label: "Plan", desc: "안전보건 목표, 경영방침, 위험성평가 계획 수립" },
              { step: "D", label: "Do", desc: "TBM 실시, 안전점검, 교육, 위험 조치 실행" },
              { step: "C", label: "Check", desc: "경영책임자 직접 점검 (반기 1회), 이행 상황 확인" },
              { step: "A", label: "Act", desc: "미흡 사항 개선, 재발방지 대책 수립 및 기록" },
            ].map((item) => (
              <div className="ex-pdca-step" key={item.step}>
                <div className="ex-pdca-letter">{item.step}</div>
                <div className="ex-pdca-content">
                  <div className="ex-pdca-label">{item.label}</div>
                  <div className="ex-pdca-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <p>이 4단계가 서류로 연결되면 "체계가 작동했다"는 증거가 됩니다.</p>
          <p>반기 1회 경영책임자 점검 일지 하나만 있어도 큰 차이가 납니다.</p>

          <h2 className="sm-h2">지금 당장 확인할 것</h2>

          <div className="ex-now-check">
            {[
              { q: "올해 위험성평가 결과가 파일로 있는가?", sub: "날짜, 작업명, 위험요인, 조치 내용 포함" },
              { q: "경영책임자 직접 점검 일지가 있는가?", sub: "상반기 또는 하반기 중 1회 이상, 서명 포함" },
              { q: "위험 보고 건에 대한 조치 결과가 기록으로 있는가?", sub: "보고만 있고 조치 기록 없으면 위험" },
            ].map((item, i) => (
              <div className="ex-now-item" key={i}>
                <div className="ex-now-check-box"></div>
                <div>
                  <div className="ex-now-q">{item.q}</div>
                  <div className="ex-now-sub">{item.sub}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="sm-cta">
            <div className="sm-cta-question">9대 의무 이행 현황, 지금 확인해보세요</div>
            <p>현장통으로 안전관리 기록을 체계화하고<br />중대재해처벌법 대응 체계를 점검해보세요.</p>
            <div className="sm-cta-buttons">
              <a href="/#contact" className="sm-cta-btn primary">
                무료체험 문의하기 →
              </a>
              <Link to="/blog/serious-accident-law" className="sm-cta-btn secondary">
                중대재해처벌법 완전 가이드 →
              </Link>
            </div>
          </div>

          <div className="blog-tags">
            {["#중대재해처벌법", "#면책기준", "#경영책임자", "#안전보건관리체제", "#PDCA", "#판례", "#건설사경영"].map(tag => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          <div className="blog-related">
            <h3>다음으로 읽으면 좋은 글</h3>
            <div className="related-grid">
              <Link to="/blog/executive-punishment-conditions" className="related-card">
                <div className="related-card-tag">경영자 가이드</div>
                <div className="related-card-title">사고 났을 때 대표이사가 처벌받는 조건 3가지</div>
              </Link>
              <Link to="/blog/serious-accident-law" className="related-card">
                <div className="related-card-tag">법규 가이드</div>
                <div className="related-card-title">중대재해처벌법 건설사 실무 대응 가이드 [2026년]</div>
              </Link>
              <Link to="/blog/risk-assessment-5steps" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">이번 달 위험성평가, 빠진 항목 없이 끝내는 5단계</div>
              </Link>
            </div>
          </div>

        </article>

        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostExemption;
